var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80467 12.138L10 5.94266L7.05733 3L0.862 9.19533C0.776667 9.28066 0.716 9.388 0.686667 9.50466L0 13L3.49467 12.3133C3.612 12.284 3.71933 12.2233 3.80467 12.138ZM12 3.94266C12.5207 3.422 12.5207 2.578 12 2.05733L10.9427 0.999997C10.422 0.47933 9.578 0.47933 9.05733 0.999997L8 2.05733L10.9427 5L12 3.94266Z",
    fill: "#24DFBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ba72ebb56c92414b8d9ee0537c5b27ef.svg";
export { ForwardRef as ReactComponent };